




























































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetExamList$, GetAllBanjis$, DeleteExams$ } from "@/request/jxgl";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../components/left-nav.vue";
import ExamTable from "./exam-list.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    ExamTable,
    Pagination,
  },
})
export default class KsglList extends Vue {
  private filters: any = {
    考试状态: "",
    class_id: "",
    考试名称: "",
    current_page: 1,
    total_count: 0,
    page_count: 10,
    order_value: 0,
  };
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 列表
  private banjis: any[] = [];
  private exams: any[] = [];
  private setFilters() {
    localStorage.setItem("ksglListFilters", JSON.stringify(this.filters));
  }
  // 获得全部班级列表
  private fetchAllBanji() {
    GetAllBanjis$(this).then((data) => {
      this.banjis = data;
    });
  }
  // 选中改变
  private selectChange(value, item) {
    if (item.selected) {
      this.selectedMessages.push(item);
      this.selectedMessages = _.uniqBy(this.selectedMessages, "exam_id");
    } else {
      const index = _.findIndex(this.selectedMessages, "exam_id");
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 跳转添加考试
   */
  private jumpDetail() {
    this.$router.push("/main/jxgl/ksgl-detail");
  }
  /**
   * @description 获得考试列表
   */
  private fetchExamList() {
    const params = _.cloneDeep(this.filters);
    GetExamList$(this, params).then((data: any) => {
      // console.log(data);
      data.exams.forEach((exam: any) => {
        const inc = _.findIndex(this.selectedMessages, (i) => {
          return i["exam_id"] === exam["exam_id"];
        });
        if (inc !== -1) {
          exam["selected"] = true;
        } else {
          exam["selected"] = false;
        }
      });
      this.$set(this, "exams", data.exams);
      this.filters.total_count = data.total_count;
      this.setFilters();
    });
  }
  /**
   * @description 改变排序顺序
   */
  private changeOrderValue() {
    this.filters.order_value = this.filters.order_value === 0 ? 1 : 0;
    this.search();
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.current_page = 1;
    this.fetchExamList();
  }
  /**
   * @description 全选
   */
  private selectAll() {
    this.exams.forEach((exam: any) => {
      exam["selected"] = true;
      this.selectedMessages.push(exam);
    });
    this.selectedMessages = _.uniqBy(this.selectedMessages, "exam_id");
  }
  /**
   * @description 批量删除
   */
  private deleteThese() {
    this.$confirm("删除后将无法找回，您确定要删除么？", {
      title: "温馨提示",
    })
      .then((value) => {
        const arr: any[] = [];
        this.selectedMessages.forEach((item: any) => {
          arr.push(item.exam_id);
        });
        const params: any = {
          data: {
            exam_ids: arr,
          },
        };
        DeleteExams$(this, params).then((data: any) => {
          this.$message.success("删除成功");
          this.selectedMessages = [];
          this.search();
        });
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.current_page = val;
    this.fetchExamList();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    const localFilters = localStorage.getItem("ksglListFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        考试状态: "",
        class_id: "",
        考试名称: "",
        current_page: 1,
        total_count: 0,
        page_count: 10,
        order_value: 0,
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    this.fetchAllBanji();
    this.fetchExamList();
  }
}
